import React from "react";

import { AddFilterBaseFunc, IFilterKeys, IFilters, IPlotData, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/mdt";
import { ChartOrientation, ChartType, QoolDashChart } from "../core";

interface IProps {
	plotData: IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

export function TumourStageChart(props: IProps) {

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: "Stage" }  }}
			yAxis={{ horizontalOrientation: { label: "Stage" }, verticalOrientation: { label: "Number of Diagnoses" }	}}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: true } }}
			defaultChartOrientation={ChartOrientation.Vertical}
			defaultChartType={ChartType.Bar}
			chartTitle="Overall Stage"
			filterKey={DashboardFilterKeys.TnmStage.key}
			plotData={[props.plotData]}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="Diagnoses"
			sortUnknownToEnd={true}
			chartIcons={{
				line: false
			}}
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
		/>
	)
}
